export default __webpack_public_path__ + "img/LazJxdPR.94b9df9f.svg";